export default __webpack_public_path__ + "static/media/certifi_11.33cff1a6.png";